import React from 'react'

const SearchTourMoreButton = (props) => {
    return <button className="btn__search-tour-more" onClick={props.onContinue}>Ещё туры</button>
}

export default SearchTourMoreButton;